const Capitalize = {
  methods: {
    capitalize(string) {
      let uppercase = string.charAt(0).toUpperCase() + string.slice(1)
      return uppercase.replace(/_/g, ' ')
    },
  },
}

export default Capitalize
